import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Store } from '@ngxs/store';
import { Part } from '@dis/models';

import { PartsState } from '../../jtms';

@Component({
  selector: 'part-image',
  templateUrl: './part-image.component.html',
  styleUrls: ['./part-image.component.scss'],
  imports: [

  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PartImageComponent {

  partNumber = input.required<string>();

  // Optional inputs
  rotateImage = input<boolean>(false);
  showConnections = input<boolean>(false);
  height = input<number>(225);
  width = input<number>(50);
  // 'horizontal' lays the connection labels at either end of the image (for long, unrotated
  // assembly strips) instead of above and below it.
  layout = input<'vertical' | 'horizontal'>('vertical');

  // Explicit connection strings (e.g. sourced from SQL Connect via the caller's own partId FK
  // relation). When provided, these take precedence over the legacy sheet-backed PartsState
  // lookup below, so callers with SQL Connect data can avoid the PartSheetStore entirely.
  topConnection = input<string | null>(null);
  bottomConnection = input<string | null>(null);

  constructor(
    private store: Store,
  ) {

  }

  get imageUrl() {
    const options = [
      this.width() ? `width=${this.width()}` : null,
      this.height() ? `height=${this.height()}` : null,
      this.rotateImage() ? 'rotate' : null,
    ].filter(Boolean).join(",");
    return `https://jtms.drillingllc.com/cdn/images/tools/${options}/${this.partNumber()}.png`
  }

  // Recomputed whenever topConnection()/bottomConnection() change, so once a caller's SQL
  // Connect-sourced inputs resolve (they start out null while their query is still loading),
  // this stops falling back to the legacy PartsState lookup instead of being stuck with
  // whatever the inputs happened to be on first mount.
  protected $legacyPart = computed((): Part | undefined => {
    if (!this.showConnections() || this.topConnection() != null || this.bottomConnection() != null) {
      return undefined;
    }
    return this.store.selectSnapshot(PartsState.getById(this.partNumber()));
  });

}
